import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import LayoutComponent from '../components/containers/Layout';
import Sidebar from '../components/containers/Sidebar';
import { PageLoader } from '../shared/pageLoader/PageLoader';
import { Auth_Routes } from '../constants/ROUTES/Auth_Routes';
import { useSelector } from 'react-redux';

const AuthenticatedRoutes = () => {

    const screenRoutes = useSelector((state) => state.common.screenRoutes);
    const PageNotFound = React.lazy(() => import('../shared/pageNotFound/PageNotFound'))

    return (
        <div style={{
            width: "100%",
            height: "100vh",
            overflow: "auto",

        }}
        >
            <div style={{ display: "flex", gap: "20px" }} >
                <Sidebar />
                <LayoutComponent >
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            {Auth_Routes?.map((route) => {
                                const matchedScreen = screenRoutes?.find(
                                    (apiRoute) =>
                                        route.ROUTE_CODE === apiRoute.screenCode || route.ROUTE_CODE === 'MY_PROFILE' || route.ROUTE_CODE === 'METADATA'
                                );

                                return matchedScreen ? (
                                    <Route key={route.ROUTE_CODE} path={route.ROUTE_PATH} element={route.ROUTE_COMPONENT} />
                                ) : null;
                            })}

                            {/* Catch-all for unmatched routes */}
                            <Route path="*" element={<PageNotFound />} />
                        </Routes>

                    </Suspense>
                </LayoutComponent>
            </div>
        </div >
    );
};

export default AuthenticatedRoutes;